import React from "react";

import { faExternalLinkAlt } from "@fortawesome/pro-solid-svg-icons/faExternalLinkAlt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "antd/es/tooltip";
import { defineMessages, useIntl } from "react-intl";
import { Link } from "react-router-dom";

import { EntityType, EntityTypesSupportingRoutes } from "@mapmycustomers/shared/types/entity";
import { Button } from "@mapmycustomers/ui";

import Path from "@app/enum/Path";

import styles from "./Count.module.scss";

interface Props {
  count: number;
  entityType: EntityTypesSupportingRoutes;
}

const messages = defineMessages({
  [EntityType.COMPANY]: {
    id: "map.tool.leadFinder.addRecords.count.companies",
    defaultMessage: "{count, plural, one {Company} other {Companies}}{br}added",
    description: "Lead Finder Results Counter - Companies",
  },
  [EntityType.PERSON]: {
    id: "map.tool.leadFinder.addRecords.count.people",
    defaultMessage: "{count, plural, one {Person} other {People}}{br}added",
    description: "Lead Finder Results Counter - People",
  },
});

const tooltips = defineMessages({
  [EntityType.COMPANY]: {
    id: "map.tool.leadFinder.addRecords.count.tooltip.companies",
    defaultMessage: "View New Companies",
    description: "Lead Finder Results Counter - View New Companies",
  },
  [EntityType.PERSON]: {
    id: "map.tool.leadFinder.addRecords.count.tooltip.people",
    defaultMessage: "View New People",
    description: "Lead Finder Results Counter - View New People",
  },
});

const Count: React.FC<Props> = ({ count, entityType }) => {
  const intl = useIntl();

  const entityPath = entityType === EntityType.COMPANY ? Path.COMPANY : Path.PEOPLE;
  const actionLink = `${entityPath}?sort=-createdAt`;

  return (
    <div className={styles.container}>
      <span className={styles.number}>{count}</span>

      <span className={styles.note}>
        <Tooltip placement="bottom" title={intl.formatMessage(tooltips[entityType])}>
          <Link target="_blank" to={actionLink}>
            <Button
              className={styles.btn}
              rightIcon={
                <FontAwesomeIcon className={styles.externalLinkIcon} icon={faExternalLinkAlt} />
              }
              type="link"
            >
              {intl.formatMessage(messages[entityType], {
                br: <br />,
                count,
              })}
            </Button>
          </Link>
        </Tooltip>
      </span>
    </div>
  );
};

export default Count;
